var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#header",
      "data-scroll": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_pagetop.svg"),
      "alt": "PAGE TOP"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/logo_footer.svg"),
      "alt": "株式会社まつや"
    }
  })]), _vm._v(" "), _c('address', [_vm._v("〒929-1171 石川県かほく市木津ハ14番地の2"), _c('span', [_vm._v("TEL.076-285-2222")])]), _vm._v(" "), _c('small', [_vm._v("Copyrightⓒ 2017 Matsuya Co., Ltd. All rights reserved.")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fff7a40","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalFooter.vue
// module id = 99
// module chunks = 0